if (!customElements.get("lsg-footer")) customElements.define("lsg-footer", class LSGFooter extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            navbarToogle: ".js-lsg-footer-nav-toggle",
            localizationSelect: ".js-lsg-localization-selector"
        };

        this.navbarToogle = this.querySelectorAll(this.selectors.navbarToogle);
        this.localizationSelect = this.querySelectorAll(this.selectors.localizationSelect);
        this.init();
    }

    init() {
        this.navbarToogle.forEach(el => {
            el.addEventListener('click', () => {
                el.setAttribute("aria-expanded", !(el.getAttribute("aria-expanded") == 'true'));
            })
        });
        this.localizationSelect.forEach(el => {
            el.addEventListener('change', () => {
                el.closest('form').submit();
            })
        });
    }
});
